import { useState } from 'react'
import { Box } from '@mui/material'
import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './hooks/useAuth'
import Header from './components/Header'
import SettingsDialog from './components/SettingsDialog'
import RequireAuth from './components/RequireAuth'
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import InvoiceAnalyserPage from './pages/InvoiceAnalyserPage'
import DatabasePage from './pages/DatabasePage'
import AdminPage from './pages/AdminPage'
import PoTrackingPage from './pages/PoTrackingPage'
import { ErrorBoundary } from './components/ErrorBoundary'
import { loadSettings, saveSettings } from './utils/storage'

function AppContent() {
  const [settingsOpen, setSettingsOpen] = useState(false)
  const [settings, setSettingsState] = useState(() => loadSettings())

  const handleSettingsSave = (newSettings: typeof settings) => {
    saveSettings(newSettings)
    setSettingsState(newSettings)
    setSettingsOpen(false)
  }

  return (
    <ErrorBoundary>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: 'background.default' }}>
        <Routes>
          {/* Public route - Login */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected routes */}
          <Route
            path="/*"
            element={
              <RequireAuth>
                <Header
                  onOpenSettings={() => setSettingsOpen(true)}
                  appName={import.meta.env.VITE_APP_NAME || 'FLIXALIO'}
                />
                <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                  <Routes>
                    <Route path="/" element={<DashboardPage />} />
                    <Route path="/invoice-analyser" element={<InvoiceAnalyserPage />} />
                    <Route path="/database" element={<DatabasePage />} />
                    <Route path="/po-tracking" element={<PoTrackingPage />} />
                    <Route
                      path="/admin"
                      element={
                        <RequireAuth requireAdmin>
                          <AdminPage />
                        </RequireAuth>
                      }
                    />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Box>
              </RequireAuth>
            }
          />
        </Routes>

        <SettingsDialog
          open={settingsOpen}
          onClose={() => setSettingsOpen(false)}
          onSave={handleSettingsSave}
          initialSettings={settings}
        />
      </Box>
    </ErrorBoundary>
  )
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}

export default App
